import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 19 1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 1\" id=\"icon-minus\">\n  <path fill=\"#171818\" fill-rule=\"evenodd\" d=\"M39.5,25 C39.7761424,25 40,25.2238576 40,25.5 L40,43.5 C40,43.7761424 39.7761424,44 39.5,44 C39.2238576,44 39,43.7761424 39,43.5 L39,25.5 C39,25.2238576 39.2238576,25 39.5,25 Z\" transform=\"rotate(90 41.5 2.5)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol